namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_command extends $.$shm_hitalama_map_widget_float_table_command {
		@ $mol_mem
		event_async() {
			const events = this.event()
			// Unlike text input, a new command must not cancel an unfinished click.
			return Object.fromEntries( Object.keys( events ).map( name => [ name,
				( event: Event )=> $mol_wire_async( events )[ name ]( event ),
			] ) )
		}
	}
}
